
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { stringStep } from '../../../concepts/commands/CommandWizard';
import { ReadyCheckController } from './ReadyCheckController';


export const readyCheckStart = defineCommand(
    'readyCheckStart',
    'Ready Check: Start',
    r => {
        r.call(ReadyCheckController).startNew();
    },
);

export const readyCheckFinish = defineCommand(
    'readyCheckFinish',
    'Ready Check: Finish',
    r => {
        r.call(ReadyCheckController).finish();
    }
);

export const readyCheckToggle = defineCommand(
    'readyCheckToggle',
    'Ready Check: Toggle',
    r => {
        const ctrl = r.call(ReadyCheckController);
        if (ctrl.active) ctrl.finish();
        else ctrl.startNew();
    },
);

export const readyCheckRespond = defineCommand(
    'readyCheckRespond',
    'Ready Check: Respond',
    (r, [yn]: [string | boolean]) => {
        const value = typeof (yn) === 'boolean' ? yn : (yn || '').trim().toLowerCase().startsWith('y');
        r.call(ReadyCheckController).respondWith(value);
    },
    [
        stringStep('ready', 'Are you ready? [Y/n]', 'Y')
    ]
);

export const inReadyCheckCommands = () => inCommands(
    readyCheckStart,
    readyCheckRespond,
);

